"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Wizard/Recipients/NewPatientForm.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

var _Form = require('web/components/Form');
var _pending = require('./pending');
var _noAutofill = require('./noAutofill');
var _typedFormat = require('./typedFormat');
var _newPatientProblems = require('./newPatientProblems');
var _TagField = require('web/screens/Directory/Forms/TagField'); var _TagField2 = _interopRequireDefault(_TagField);

const SEARCH_DELAY_MS = 250

/* "Jordan Lee", as the v2 tables name patients. */
const fullName = (p) =>
  [p.FirstName, p.LastName].filter(Boolean).join(' ') || p.Name || 'Unnamed patient'

const digits = (s) => s.replace(/\D/g, '')



const toPicked = (p) => ({
  PatientKey: p.PatientKey, FirstName: p.FirstName, LastName: p.LastName, Phone: p.Phone, Email: p.Email, MRN: p.MRN,
})









/* The patient a phone, email or MRN belongs to (review R800-3). The directory
 * search matches names only, so contacts go through the recipient matching:
 * a preview of one new-patient row resolves it like the Add would (MRN, then
 * phone, then email). match is undefined until the contact has an answer;
 * retry asks again after a failure. */
const useContactMatch = (campaignKey, contact) => {
  const request = contact ? JSON.stringify(contact) : ''
  const [answer, setAnswer] = _react.useState(null)
  const [attempt, setAttempt] = _react.useState.call(void 0, 0)
  _react.useEffect.call(void 0, 
    () => {
      if (!request) return
      let isCurrent = true
      const timer = setTimeout(
        () => _actions2.default.previewCampaignRecipients({
          CampaignKey: campaignKey,
          Sources: [{ Kind: 'rows', Rows: [{ NewPatient: JSON.parse(request), Values: {} }] }],
        })
          .then(({ Sources: [rows] }) => {
            const patient = _optionalChain([rows, 'optionalAccess', _ => _.Kind]) === 'rows' ? _optionalChain([rows, 'access', _2 => _2.RowResults, 'access', _3 => _3[0], 'optionalAccess', _4 => _4.Patient]) : undefined
            if (isCurrent) setAnswer({ request, patient: patient ? toPicked(patient) : null, isFailed: false })
          })
          .catch(() => { if (isCurrent) setAnswer({ request, patient: null, isFailed: true }) }),
        SEARCH_DELAY_MS,
      )
      return () => {
        isCurrent = false
        clearTimeout(timer)
      }
    },
    [campaignKey, request, attempt],
  )
  const retry = _react.useCallback.call(void 0, () => {
    setAnswer(null)
    setAttempt(n => n + 1)
  }, [])
  return { match: answer && answer.request === request ? answer : undefined, retry }
}

const FIELDS = [
  { field: 'FirstName', label: 'First name', placeholder: 'First name' },
  { field: 'LastName', label: 'Last name', placeholder: 'Last name' },
  { field: 'Phone', label: 'Phone', placeholder: '(206) 555-0100', type: 'tel' },
  { field: 'Email', label: 'Email', placeholder: 'name@example.com', type: 'email' },
  { field: 'DOB', label: 'Date of birth', placeholder: 'MM/DD/YYYY' },
  { field: 'MRN', label: 'MRN', placeholder: '' },
]

/* The typed contact that a matched patient has (or, with no patient, the
 * first typed): the hint names it. */
const matchingContact = (fields, p) => {
  const phone = digits(fields.Phone)
  if (p && fields.MRN.trim() && fields.MRN.trim() === p.MRN) return fields.MRN.trim()
  if (p && phone && phone.slice(-10) === digits(p.Phone).slice(-10)) return fields.Phone.trim()
  if (p && fields.Email.trim() && fields.Email.trim().toLowerCase() === p.Email.toLowerCase()) return fields.Email.trim()
  return fields.MRN.trim() || fields.Phone.trim() || fields.Email.trim()
}















/* D-84: New patient, inside Add existing patients (x-pk6b): the
 * new-patient form (moved from Add existing, then the New patient dialog of
 * D-60), in one step with no values. Create and select saves the patient and
 * takes them back to the list, ticked; the broadcast's variables take their
 * defaults, as for anyone added from the list (D-55). A phone, email or MRN
 * already a patient's offers that patient instead and creates nobody; so
 * does a blank name. */
const NewPatientForm = ({ campaignKey, isCreating, error, onBack, tags, onCreate, onUseExisting }) => {
  const id = _react.useId.call(void 0, )
  const [fields, setFields] = _react.useState(_pending.EMPTY_NEW_PATIENT)
  const [tagValue, setTagValue] = _react.useState(_TagField.EMPTY_TAG_FIELD)
  // A masked field keeps its caret by the edit, not at the end (R800-15).
  const inputs = _react.useRef({})
  const [caret, setCaret] = _react.useState(null)
  _react.useLayoutEffect.call(void 0, 
    () => {
      if (!caret) return
      _optionalChain([inputs, 'access', _5 => _5.current, 'access', _6 => _6[caret.field], 'optionalAccess', _7 => _7.setSelectionRange, 'call', _8 => _8(caret.at, caret.at)])
    },
    [caret, fields],
  )
  const [hasTried, setHasTried] = _react.useState.call(void 0, false)
  const problems = _newPatientProblems.newPatientProblems.call(void 0, fields, { isNameRequired: true })
  const hasProblem = Object.keys(problems).length > 0
  // Nothing is flagged until the user tries to add; then it updates as they type.
  const shown = hasTried ? problems : {}

  // Auto-match: the MRN, phone or email typed may already be a patient's,
  // matched the way the Add would match this row (R800-3).
  const contact = {}
  if (fields.MRN.trim()) contact.MRN = fields.MRN.trim()
  if (digits(fields.Phone).length >= 7) contact.Phone = fields.Phone.trim()
  if (fields.Email.includes('@')) contact.Email = fields.Email.trim()
  const hasContact = Object.keys(contact).length > 0
  const { match, retry } = useContactMatch(campaignKey, hasContact ? contact : null)
  const existing = _nullishCoalesce(_optionalChain([match, 'optionalAccess', _9 => _9.patient]), () => ( null))
  // Until the typed contact is known to be no one's, nobody is created: not
  // while it's checked, and not when the check failed (review F-4, D-92), as
  // the server would create a second patient with the same contact. Retry asks again.
  const isChecking = hasContact && !match
  const isUnknown = isChecking || !!_optionalChain([match, 'optionalAccess', _10 => _10.isFailed])

  const submit = () => {
    setHasTried(true)
    if (hasProblem || isUnknown || existing || isCreating) return
    // B2: the server is sent the date as YYYY-MM-DD.
    onCreate({ ...fields, DOB: _typedFormat.dobToIso.call(void 0, fields.DOB) }, tagValue)
  }

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', { className: "broadcast-pick-new", __self: this, __source: {fileName: _jsxFileName, lineNumber: 161}}
        , _react2.default.createElement('button', { type: "button", className: "broadcast-link-button broadcast-pick-new--back" , disabled: isCreating, onClick: onBack, __self: this, __source: {fileName: _jsxFileName, lineNumber: 162}}, "‹ Back to the list"

        )
        , _react2.default.createElement('h3', { className: "broadcast-pick-new--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 165}}, "New patient" )
        , _react2.default.createElement('p', { className: "broadcast-pick-new--lead", __self: this, __source: {fileName: _jsxFileName, lineNumber: 166}}, "They are saved to your patients and selected in the list, ready to add. The campaign's variables take their defaults, as for anyone added here."

        )
      , _react2.default.createElement('div', { className: "broadcast-add-dialog--form", __self: this, __source: {fileName: _jsxFileName, lineNumber: 169}}
        ,  FIELDS.map(f => {
          const isContact = f.field === 'Phone' || f.field === 'Email'
          const fieldProblem = shown[f.field]
          const isInvalid = !!fieldProblem || (isContact && !!shown.Contact)
          const describedBy = fieldProblem ? `${id}-${f.field}` : isContact && shown.Contact ? `${id}-problem` : undefined
          return (
            _react2.default.createElement('label', { key: f.field, className: "broadcast-add-dialog--field", __self: this, __source: {fileName: _jsxFileName, lineNumber: 176}}
              , _react2.default.createElement('span', { className: "broadcast-add-dialog--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 177}}
                ,  f.label 
                ,  (f.field === 'DOB' || f.field === 'MRN') && _react2.default.createElement('span', { className: "broadcast-add-dialog--optional", __self: this, __source: {fileName: _jsxFileName, lineNumber: 179}}, " (optional)" ) 
              )
              , _react2.default.createElement('input', {
                // oxlint-disable-next-line jsx-a11y/no-autofocus -- the user just chose to create a patient
                autoFocus: f.field === 'FirstName',
                className: _classBuilder2.default.call(void 0, 'blm-text-input', isInvalid && 'broadcast-pending--input-invalid'),
                type: _nullishCoalesce(f.type, () => ( 'text')),
                'aria-label': f.label,
                placeholder: f.placeholder,
                'aria-invalid': isContact || fieldProblem ? isInvalid : undefined,
                'aria-describedby': describedBy,
                ..._noAutofill.NO_AUTOFILL,
                value: fields[f.field],
                ref: el => { inputs.current[f.field] = el },
                onChange: e => {
                  const { value, selectionStart } = e.target
                  // A1/A2: the phone and the date format as they're typed.
                  if (f.field === 'Phone' || f.field === 'DOB') {
                    const edit = f.field === 'Phone' ? _typedFormat.editPhone : _typedFormat.editDob
                    const inputType = (e.nativeEvent ).inputType
                    const next = edit(fields[f.field], value, _nullishCoalesce(selectionStart, () => ( value.length)), inputType)
                    setFields(x => ({ ...x, [f.field]: next.value }))
                    setCaret({ field: f.field, at: next.caret })
                    return
                  }
                  setFields(x => ({ ...x, [f.field]: value }))
                },
                onKeyDown: e => { if (e.key === 'Enter') submit() }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 181}}
              )
              ,  fieldProblem && (
                _react2.default.createElement('span', { id: `${id}-${f.field}`, className: "broadcast-wizard--error broadcast-add-dialog--field-error" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 209}}
                  ,  fieldProblem 
                )
              )
            )
          )
        })
        , _react2.default.createElement('div', { className: "broadcast-add-dialog--field broadcast-add-dialog--tags" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 216}}
          , _react2.default.createElement('span', { className: "broadcast-add-dialog--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 217}}, "Tags"
            , _react2.default.createElement('span', { className: "broadcast-add-dialog--optional", __self: this, __source: {fileName: _jsxFileName, lineNumber: 218}}, " (optional)" )
          )
          , _react2.default.createElement(_TagField2.default, {
            tags: tags,
            value: tagValue,
            onChange: setTagValue,
            createdWhen: "when you create the patient"    ,
            isDisabled: isCreating,
            title: null, __self: this, __source: {fileName: _jsxFileName, lineNumber: 220}}
          )
        )
      )
      , _react2.default.createElement('div', { className: "broadcast-add-dialog--messages", __self: this, __source: {fileName: _jsxFileName, lineNumber: 230}}
        ,  shown.Contact && _react2.default.createElement('p', { id: `${id}-problem`, role: "alert", className: "broadcast-wizard--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 231}},  shown.Contact ) 
        ,  !shown.Contact && _react2.default.createElement('p', { className: "broadcast-add-dialog--note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 232}}, "A phone or an email is required, so the patient can get the message."             ) 
        ,  _optionalChain([match, 'optionalAccess', _11 => _11.isFailed]) && (
          _react2.default.createElement('div', { role: "alert", className: "broadcast-banner broadcast-add-dialog--match" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 234}}
            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 235}}, "Couldn't check whether "   ,  matchingContact(fields, null) , " belongs to a patient. Nobody is created until it's checked."          )
            , _react2.default.createElement('button', { type: "button", className: "broadcast-link-button", onClick: retry, __self: this, __source: {fileName: _jsxFileName, lineNumber: 236}}, "Retry")
          )
        )
        ,  existing && (
          _react2.default.createElement('div', { className: "broadcast-banner broadcast-add-dialog--match" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 240}}
            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 241}},  matchingContact(fields, existing) , " already belongs to "    ,  fullName(existing) , ".")
            , _react2.default.createElement('button', { type: "button", className: "broadcast-link-button", disabled: isCreating, onClick: () => onUseExisting(existing), __self: this, __source: {fileName: _jsxFileName, lineNumber: 242}}, "Select "
               ,  fullName(existing) , " instead"
            )
          )
        )
        ,  error && _react2.default.createElement('p', { role: "alert", className: "broadcast-wizard--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 247}},  error ) 
      )
      )
      /* Back and Create, together; × and Esc still close the dialog. */
      , _react2.default.createElement('div', { className: "broadcast-upload-dialog--foot broadcast-pick--foot" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 251}}
        , _react2.default.createElement('span', { className: "broadcast-wizard--grow", __self: this, __source: {fileName: _jsxFileName, lineNumber: 252}} )
        , _react2.default.createElement(_Form.Button, { isSecondary: true, isDisabled: isCreating, onClick: onBack, __self: this, __source: {fileName: _jsxFileName, lineNumber: 253}}, "Back")
        , _react2.default.createElement(_Form.Button, { isDisabled: (hasTried && hasProblem) || !!existing || !!_optionalChain([match, 'optionalAccess', _12 => _12.isFailed]), isLoading: isCreating, onClick: submit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 254}}, "Create and select"  )
      )
    )
  )
}

exports. default = NewPatientForm
